import { PreviewParamsYupSchema } from '@/components/Preview/OverlayPreview/constants';
import { CustomFeedParamsYupSchema } from '@/features/CustomFeedV2';
import { PortfolioParamsYupSchema } from '@/features/PortfolioManager/constants';

const OVERLAY_TYPES = {
  CustomFeed: 'custom-feed',
  Preview: 'preview',
  Portfolio: 'portfolio',
} as const;

type OverlayType = (typeof OVERLAY_TYPES)[keyof typeof OVERLAY_TYPES];

const OVERLAY_QUERY_PARAMS = {
  [OVERLAY_TYPES.CustomFeed]: CustomFeedParamsYupSchema,
  // todo: colocate schema later
  [OVERLAY_TYPES.Preview]: PreviewParamsYupSchema,
  [OVERLAY_TYPES.Portfolio]: PortfolioParamsYupSchema,
  // new params will be added here
};

export { OVERLAY_TYPES, OVERLAY_QUERY_PARAMS };
export type { OverlayType };
